/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateProcessFileDto,
  ListWorkflowProcessesResult,
  ProcessHistoryDiffEntity,
  RestoreHistoryDto,
  UpdateProcessDto,
  WorkflowProcessEntity,
} from '../models/index';
import {
    CreateProcessFileDtoFromJSON,
    CreateProcessFileDtoToJSON,
    ListWorkflowProcessesResultFromJSON,
    ListWorkflowProcessesResultToJSON,
    ProcessHistoryDiffEntityFromJSON,
    ProcessHistoryDiffEntityToJSON,
    RestoreHistoryDtoFromJSON,
    RestoreHistoryDtoToJSON,
    UpdateProcessDtoFromJSON,
    UpdateProcessDtoToJSON,
    WorkflowProcessEntityFromJSON,
    WorkflowProcessEntityToJSON,
} from '../models/index';

export interface DeleteProcessDataFileRequest {
    processId: string;
    createProcessFileDto: CreateProcessFileDto;
}

export interface DeleteWorkflowProcessRequest {
    processId: string;
}

export interface GetDiffsRequest {
    processId: string;
}

export interface GetProcessDataFileDownloadUrlRequest {
    processId: string;
    disposition: string;
    createProcessFileDto: CreateProcessFileDto;
}

export interface GetWorkflowProcessRequest {
    processId: string;
}

export interface ListWorkflowProcessHistoriesRequest {
    processId: string;
}

export interface ListWorkflowProcessesRequest {
    filter?: string;
    skip?: string;
    take?: string;
}

export interface RestoreWorkflowProcessHistoryRequest {
    processId: string;
    historyId: string;
    restoreHistoryDto?: RestoreHistoryDto;
}

export interface UpdateWorkflowProcessRequest {
    processId: string;
    updateProcessDto: UpdateProcessDto;
}

export interface UploadProcessDataFileRequest {
    processId: string;
    createProcessFileDto: CreateProcessFileDto;
}

/**
 * 
 */
export class ProcessApi extends runtime.BaseAPI {

    /**
     * プロセスデータに紐づいた指定のファイルを削除する
     */
    async deleteProcessDataFileRaw(requestParameters: DeleteProcessDataFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling deleteProcessDataFile().'
            );
        }

        if (requestParameters['createProcessFileDto'] == null) {
            throw new runtime.RequiredError(
                'createProcessFileDto',
                'Required parameter "createProcessFileDto" was null or undefined when calling deleteProcessDataFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/processes/{processId}/files/delete`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateProcessFileDtoToJSON(requestParameters['createProcessFileDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * プロセスデータに紐づいた指定のファイルを削除する
     */
    async deleteProcessDataFile(requestParameters: DeleteProcessDataFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.deleteProcessDataFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ワークフロープロセスを1件削除する。
     */
    async deleteWorkflowProcessRaw(requestParameters: DeleteWorkflowProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowProcessEntity>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling deleteWorkflowProcess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/processes/{processId}`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowProcessEntityFromJSON(jsonValue));
    }

    /**
     * ワークフロープロセスを1件削除する。
     */
    async deleteWorkflowProcess(requestParameters: DeleteWorkflowProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowProcessEntity> {
        const response = await this.deleteWorkflowProcessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定したIDのワークフロープロセスに関連する履歴の差分を取得する。
     */
    async getDiffsRaw(requestParameters: GetDiffsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProcessHistoryDiffEntity>>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling getDiffs().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/processes/{processId}/diffs`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProcessHistoryDiffEntityFromJSON));
    }

    /**
     * 指定したIDのワークフロープロセスに関連する履歴の差分を取得する。
     */
    async getDiffs(requestParameters: GetDiffsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProcessHistoryDiffEntity>> {
        const response = await this.getDiffsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定したファイルの一時ダウンロードURLを発行する（有効期限15分）
     */
    async getProcessDataFileDownloadUrlRaw(requestParameters: GetProcessDataFileDownloadUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling getProcessDataFileDownloadUrl().'
            );
        }

        if (requestParameters['disposition'] == null) {
            throw new runtime.RequiredError(
                'disposition',
                'Required parameter "disposition" was null or undefined when calling getProcessDataFileDownloadUrl().'
            );
        }

        if (requestParameters['createProcessFileDto'] == null) {
            throw new runtime.RequiredError(
                'createProcessFileDto',
                'Required parameter "createProcessFileDto" was null or undefined when calling getProcessDataFileDownloadUrl().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['disposition'] != null) {
            queryParameters['disposition'] = requestParameters['disposition'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/processes/{processId}/files/getDownloadUrl`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateProcessFileDtoToJSON(requestParameters['createProcessFileDto']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * 指定したファイルの一時ダウンロードURLを発行する（有効期限15分）
     */
    async getProcessDataFileDownloadUrl(requestParameters: GetProcessDataFileDownloadUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string | null | undefined > {
        const response = await this.getProcessDataFileDownloadUrlRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 201:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * ワークフロープロセスを1件取得する。
     */
    async getWorkflowProcessRaw(requestParameters: GetWorkflowProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowProcessEntity>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling getWorkflowProcess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/processes/{processId}`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowProcessEntityFromJSON(jsonValue));
    }

    /**
     * ワークフロープロセスを1件取得する。
     */
    async getWorkflowProcess(requestParameters: GetWorkflowProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowProcessEntity> {
        const response = await this.getWorkflowProcessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定したIDのワークフロープロセスに関連するワークフロープロセス履歴一覧を取得する。
     */
    async listWorkflowProcessHistoriesRaw(requestParameters: ListWorkflowProcessHistoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WorkflowProcessEntity>>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling listWorkflowProcessHistories().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/processes/{processId}/histories`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WorkflowProcessEntityFromJSON));
    }

    /**
     * 指定したIDのワークフロープロセスに関連するワークフロープロセス履歴一覧を取得する。
     */
    async listWorkflowProcessHistories(requestParameters: ListWorkflowProcessHistoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WorkflowProcessEntity>> {
        const response = await this.listWorkflowProcessHistoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ワークフロープロセス一覧を取得する。
     */
    async listWorkflowProcessesRaw(requestParameters: ListWorkflowProcessesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListWorkflowProcessesResult>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['take'] != null) {
            queryParameters['take'] = requestParameters['take'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/processes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListWorkflowProcessesResultFromJSON(jsonValue));
    }

    /**
     * ワークフロープロセス一覧を取得する。
     */
    async listWorkflowProcesses(requestParameters: ListWorkflowProcessesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListWorkflowProcessesResult> {
        const response = await this.listWorkflowProcessesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 履歴をプロセスに復元します。復元範囲により、全体復元・データのみ復元・ワークフロー状態のみ復元を選択できます。
     * 指定した履歴時点の状態をプロセスに復元する
     */
    async restoreWorkflowProcessHistoryRaw(requestParameters: RestoreWorkflowProcessHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowProcessEntity>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling restoreWorkflowProcessHistory().'
            );
        }

        if (requestParameters['historyId'] == null) {
            throw new runtime.RequiredError(
                'historyId',
                'Required parameter "historyId" was null or undefined when calling restoreWorkflowProcessHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/processes/{processId}/restore-history/{historyId}`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))).replace(`{${"historyId"}}`, encodeURIComponent(String(requestParameters['historyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RestoreHistoryDtoToJSON(requestParameters['restoreHistoryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowProcessEntityFromJSON(jsonValue));
    }

    /**
     * 履歴をプロセスに復元します。復元範囲により、全体復元・データのみ復元・ワークフロー状態のみ復元を選択できます。
     * 指定した履歴時点の状態をプロセスに復元する
     */
    async restoreWorkflowProcessHistory(requestParameters: RestoreWorkflowProcessHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowProcessEntity> {
        const response = await this.restoreWorkflowProcessHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ワークフロープロセスを1件保存する。
     */
    async updateWorkflowProcessRaw(requestParameters: UpdateWorkflowProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowProcessEntity>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling updateWorkflowProcess().'
            );
        }

        if (requestParameters['updateProcessDto'] == null) {
            throw new runtime.RequiredError(
                'updateProcessDto',
                'Required parameter "updateProcessDto" was null or undefined when calling updateWorkflowProcess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/processes/{processId}`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProcessDtoToJSON(requestParameters['updateProcessDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowProcessEntityFromJSON(jsonValue));
    }

    /**
     * ワークフロープロセスを1件保存する。
     */
    async updateWorkflowProcess(requestParameters: UpdateWorkflowProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowProcessEntity> {
        const response = await this.updateWorkflowProcessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プロセスデータに紐づいたファイルをアップロードする
     */
    async uploadProcessDataFileRaw(requestParameters: UploadProcessDataFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling uploadProcessDataFile().'
            );
        }

        if (requestParameters['createProcessFileDto'] == null) {
            throw new runtime.RequiredError(
                'createProcessFileDto',
                'Required parameter "createProcessFileDto" was null or undefined when calling uploadProcessDataFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/processes/{processId}/files/upload`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateProcessFileDtoToJSON(requestParameters['createProcessFileDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * プロセスデータに紐づいたファイルをアップロードする
     */
    async uploadProcessDataFile(requestParameters: UploadProcessDataFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.uploadProcessDataFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
